import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./button-assets.module.scss";

export default function ButtonAssets(props: { onClick: VoidFunction }) {
	const { t } = useTranslation();

	return (
		<button className={styles.button} onClick={props.onClick}>
			{t("dashboard.map_list.assets_button")}
		</button>
	);
}
